import { module } from 'modujs';
import { html } from '../utils/environment';
import { Swiper, Lazy, Navigation, Pagination, Controller } from 'swiper';

export default class Slider extends module {

    static get OPTION_TYPES() {
        return {
            default: {
                loop: true,
                navigation: true,
            },
            double: {
                loop: true,
                modules: [Lazy, Controller],
                navigation: true,
                allowTouchMove: false,
            },
            news: {
                breakpoints: {
                    500: {
                        slidesPerView: 2.25
                    }
                },
                navigation: true,
                slidesPerView: 1.5,
            },
            articles: {
                breakpoints: {
                    500: {
                        slidesPerView: 2
                    },
                    700: {
                        slidesPerView: 2.5
                    },
                    1000: {
                        slidesPerView: 3
                    }
                },
                modules: [Lazy],
                navigation: true,
                slidesPerView: 1.5,
            },
            catalog: {
                breakpoints: {
                    500: {
                        slidesPerView: 2.25
                    },
                    700: {
                        slidesPerView: 2.75
                    },
                    1000: {
                        slidesPerView: 4
                    }
                },
                modules: [Lazy],
                navigation: true,
                slidesPerView: 1.5,
            },
            guide: {
                breakpoints: {
                    500: {
                        slidesPerView: 2.25
                    },
                    700: {
                        slidesPerView: 2.75
                    },
                    1000: {
                        slidesPerView: 4
                    },
                    1200: {
                        slidesPerView: 4.8
                    }
                },
                modules: [Lazy],
                navigation: true,
                slidesPerView: 1.5,
                slidesOffsetBefore: () => {
                    if(window.innerWidth < 700) {
                        return 0
                    }
                    return 2.05/12 * document.querySelector('[data-slider-type="guide"]').offsetWidth
                },
            },
            quotes: {
                modules: [Lazy, Pagination],
                navigation: true,
                pagination: true,
                slidesPerView: 1,
            },
            fullwidth: {
                modules: [Lazy, Pagination],
                navigation: true,
                slidesPerView: 1,
            },
        }
    }

    constructor(m) {
        super(m);

        // DOM
        this.$el = this.el
        this.$slider = this.$('slider')

        // Vars
        this.TYPE = this.getData('type') || 'default'
        const OPTIONS = Slider.OPTION_TYPES[this.TYPE] || {}

        if(OPTIONS.pagination === true) {
            OPTIONS.pagination = {
                el: this.$('pagination')[0],
                type: 'custom',
                renderCustom: (swiper, current, total) => ('0' + current).slice(-2) + ' / ' + ('0' + total).slice(-2)
            }
        }

        if(OPTIONS.navigation === true) {
            const modules = OPTIONS.modules || []
            modules.push(Navigation)
            OPTIONS.modules = modules
            OPTIONS.navigation = {
                prevEl: this.$('prev')[0],
                nextEl: this.$('next')[0],
            }
        }

        this.options = Object.assign({
            spaceBetween: 20,
        }, OPTIONS)
    }

    init() {
        this.swiper = new Swiper(this.$slider[0], this.options)

        if (this.TYPE === 'double') {
            this.swiper2 = new Swiper(this.$slider[1], {
                ...this.options,
                initialSlide: 1,
            })

            this.swiper.on('slideChange', e => console.log(e.activeIndex))
            console.log(this.swiper.activeIndex)
        }
    }

    destroy() {
        this.swiper?.destroy(true, true)
        this.swiper2?.destroy(true, true)
    }
}
